export default "__VITE_ASSET__3e97242a__"